import { registeredTabsHandlers } from '@/global/components/view-layouts/tabs-layout/common/registered-tabs-handlers'
import { registeredTableHandlers } from '@/global/components/view-layouts/tabs-layout/config/registered-table-handlers'
import { isObject } from '@/global/utils/utils'
import { api } from '@/global/services/api'
import { dateService, FORMATS } from '@/global/services/date'

export default {
  methods: {
    async onShowDamageDetails (event) {
      try {
        const { setFormData } = registeredTabsHandlers?.damages || {}
        const { id } = event?.data || {}

        if (this.showDamagesLoader !== undefined) {
          this.showDamagesLoader = true
        }
        // do not show vehicle damage if damage id is invalid
        if (!id) {
          return
        }

        // fetch damage details
        const { data } = await api('fleet').get(`vehicle-damages/${id}`)
        const formattedDate = data?.date ? dateService.formatCustom(data.date, FORMATS.isoDate, FORMATS.date) : null

        if (data?.driver?.id) {
          data.person_id = [data.driver.id]
          delete data.driver
        }
        if (formattedDate) {
          data.date = formattedDate
        }
        // params from grid display
        const { showDetails, setDetailsTitle } = this.blockConfig || {}
        const appendToDetailsTitle = formattedDate || this.$t('fleet/vehicle.details')
        const detailsTitle = this.$t('fleet.damage') + ' - ' + appendToDetailsTitle

        if (typeof setFormData === 'function' && data && isObject(data)) {
          this.damagesDetailsTitle = detailsTitle
          setDetailsTitle?.(detailsTitle)
          setFormData(data)
        }

        showDetails?.()
        this.showDamagesTable = false
        this.showDamagesDetails = true
      }
      catch (exception) {
        console.error(exception)
      }
      finally {
        if (this.showDamagesLoader !== undefined) {
          this.showDamagesLoader = false
        }
      }
    },

    onDamageDelete (event) {
      const { id, date } = event?.data || {}
      if (!id) {
        return
      }

      const title = this.$t('fleet/damages.delete_title')
      this.$set(this.informationDialogConfig, 'title', title + (date ? ' - ' + dateService.formatCustom(date, FORMATS.isoDatetime, FORMATS.date) : ''))
      this.$set(this.informationDialogConfig, 'message', this.$t('fleet/damages.delete_message'))
      this.$set(this.informationDialogConfig, 'positiveBtnText', this.$t('base.confirm'))
      this.$set(this.informationDialogConfig, 'callbackFn', () => this.onDamageDeleteCallback(event))
      this.$set(this.informationDialogConfig, 'openDialog', true)
    },

    async onDamageDeleteCallback (event) {
      try {
        const { id } = event?.data || {}
        const { fetchData } = registeredTableHandlers?.damages || {}

        await api('fleet').delete(`vehicle-damages/${id}`)

        this.$set(this.informationDialogConfig, 'openDialog', false)
        if (typeof fetchData === 'function') {
          fetchData()
        }
      }
      catch (exception) {
        console.error(exception)
      }
    },

    async onImageDelete (event) {
      try {
        const { id } = event?.file || {}
        const { index } = event || {}
        const { fetchData } = registeredTableHandlers.damages || {}

        if (!id) {
          return
        }

        await api('fleet').delete()
        this.imagesPreviewDialogConfig.images = this.imagesPreviewDialogConfig.images.filter((_, i) => i !== index)
        if (typeof fetchData === 'function') {
          fetchData()
        }
      }
      catch (exception) {
        console.error(exception)
      }
    }
  }
}
